import { HttpError } from './HttpError';

export class ForbiddenError extends HttpError {
	constructor(options?: { cause?: unknown }) {
		super('Forbidden page', 403, 403, options);
	}
}
